<template>
    <v-app v-touch:swipe="scrolling" v-on:touchmove.native="scrolling" ref="outer_container" id="outer_container">
        <div v-if="nurse.name != null" id="chat-header">
            <div style="display: flex; justify-content: center; align-items: center;">
                <div style="flex-grow: 1; width: 25%" v-if="!isEnded">
                    <v-btn :ripple="false" flat color="white" @click="endChat" v-if="!isEnded">End Chat</v-btn>
                </div>
                <div style="flex-grow: 1; width: 25%" v-if="isEnded">
                    <v-btn :ripple="false" icon @click="$router.go(-1)">
                        <v-icon class="icon-light">arrow_back</v-icon>
                    </v-btn>
                </div>
                <div style="flex-grow: 2; text-align: center; font-size: 1.5em; font-weight: bold">
                    <span v-if="displayTime != null">{{displayTime}}</span>
                    <span v-if="displayTime == null">&nbsp;</span>
                </div>
                <div style="flex-grow: 1; text-align: right; width: 25%">
                    <v-btn icon v-if="!isEnded" @click="showCallback = true">
                        <v-icon color="white">phone</v-icon>
                    </v-btn>
                    <v-btn icon>
                        <v-icon color="white" @click="showRating = true">star</v-icon>
                    </v-btn>
                </div>
            </div>
            <div style="display: flex; justify-content: center;  align-items: center;">
                <div style="padding: 5px">
                    <img style="width: 75px; height: 75px; border-radius: 50%" :src="nurse.img"/>
                </div>
                <div style="flex-grow: 1; vertical-align: middle">
                    <div style="font-size: 1.7em; font-weight: bold">{{ nurse.name }}</div>
                    <div style="font-size: 1.2em">{{ nurse.qualification }}</div>
                    <div style="font-size: 1em">{{ nurse.university }}</div>
                </div>
            </div>
        </div>
        <v-content v-if="nurse.name != null" style="padding: 145px 30px 0 30px">
            <div class="chat-container">
                <div class="chat-row chat-content" id="chat-container" >
                    <div style="">
                        <template v-for="message in chat">
                            <div :class="!message.user ? 'speech-bubble-left-outer' : 'speech-bubble-right-outer'">
                                <div :class="!message.user ? 'speech-bubble-left' : 'speech-bubble-right'">
                                    <span v-if="message.type == 'text'">
                                        {{ message.message }}
                                    </span>

                                    <span v-if="message.type == 'image'">
                                        <img style="width: 30vw; height: 30vw" :src="imageLocation(message.message)"/>
                                    </span>

                                    <span v-if="message.type == 'audio'">
                                        <audio controls controlsList="nodownload" style="max-width: 100%">
                                            <source :src="imageLocation(message.message)" type="audio/mpeg"/>
                                        </audio>
                                    </span>
                                </div>
                                <div class="chat-date" style="color: #333; font-style: italic; font-size: 0.9em">{{
                                    message.time.format("DD-MM-YYYY HH:mm:ss") }}
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <div v-if="!isEnded" ref="messageOuter" id="chat-footer" class="chat-row chat-footer" style="padding: 10px 10px 10px 10px; background: #d7ccc8">
                    <div ref="messageWrapper" style="border: none; border-radius: 15px; background-color: #efeff4; width: 100%;display: flex; justify-content: center;  align-items: center; ">
                        <v-textarea ref="message" solo v-model="message" style="padding: 0px 10px; border: 0px solid green" rows="1" v-on:blur="chatBlur" v-on:focus="chatFocus">

                        </v-textarea>

                        <div class="">
                            <v-btn icon v-if="message != ''" @click="send">
                                <v-icon color="#196392">send</v-icon>
                            </v-btn>
                            <v-btn icon v-if="message == '' && navigator.camera" @click="photo">
                                <v-icon color="#196392">photo_camera</v-icon>
                            </v-btn>
                            <v-btn icon v-on:touchstart="micStart" v-on:touchend="micEnd" v-if="message == '' && allowAudio">
                                <v-icon color="#196392">mic</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </div>
            </div>
        </v-content>

        <v-dialog v-model="showError" :persistent="true" width="500">
            <v-card>
                <v-card-text>
                    {{ errorMessage }}
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="$router.go(-1)">
                        Okay
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="showRating" width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    Rate The Chat
                </v-card-title>

                <v-card-text style="text-align: center">
                    <v-rating v-model="rating"></v-rating>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-btn color="primary" flat @click="showRating = false">
                        Close
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="rate">
                        Send Rating
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showCallback" width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    Call Back
                </v-card-title>

                <v-card-text>
                    Do you want a {{ config.practitioner.type }} to call you back?
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-btn color="primary" flat @click="showCallback = false">
                        No
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="callback">
                        Yes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="showRatingComplete" :bottom="true" :timeout="2000">
            Thank you. Your rating has been submitted.
            <v-btn color="#114c74" flat @click="showRatingComplete = false">
                Close
            </v-btn>
        </v-snackbar>
        <v-snackbar v-model="showCallbackComplete" :bottom="true" :timeout="2000">
            Your request has been sent to the {{ config.practitioner.type }}.

            <v-btn color="#114c74" flat @click="showCallbackComplete = false">
                Close
            </v-btn>
        </v-snackbar>
        <v-snackbar v-model="showRecording" :top="true" :timeout="0">
            Recording in progress...
        </v-snackbar>
    </v-app>
</template>
<script>
    import vas from '@/lib/VASClient';
    import {mapState, mapActions} from 'vuex'

    var config = require('../../../variants/' + BUILD_VARIANT + '/config.js').default;

    export default {
        data() {
            return {
                showRating: false,
                showRatingComplete: false,
                showCallback: false,
                showCallbackComplete: false,
                showRecording: false,
                rating: 0,
                chat: [],
                chatId: null,
                isEnded: false,
                endDate: null,
                message: '',
                showError: false,
                errorMessage: '',
                nurse: {
                    id: null,
                    img: null,
                    name: null,
                    qualification: null,
                },
                start: null,
                displayTime: '00:00:00',
                timer: null,
                config: config,
                navigator: navigator,
                allowAudio: false,
                chatTimer: null,
                window: window,
                handleScroll: false
            }
        },
        computed: {
            ...mapState(
                ['auth']
            )
        },
        watch: {
            message: function (val) {
                this.setInputHeight();
            }
        },
        methods: {
            scrolling() {
                if (this.handleScroll) {
                    this.$refs.message.blur();
                }
            },
            chatBlur() {
                this.handleScroll = false;

                document.getElementById('chat-container').style.display = 'block';
            },
            chatFocus() {
                document.getElementById('chat-container').style.display = 'none';

                console.log(body.scrollHeight);
                const el = document.scrollingElement || document.documentElement;
                el.scrollTo(0, document.documentElement.scrollHeight)

                var self = this;
                self.handleScroll = true;
                // setTimeout(function() {
                //     console.log("active element");
                //     console.log(document.activeElement);
                //     self.handleScroll = true;
                // }, 500)
            },
            addMessage(message) {
                if (message.type === 'call' || message.type === 'emergency') {
                    return;
                }

                this.chat.push(message);

                const el = document.scrollingElement || document.documentElement;

                setTimeout(function () {
                    el.scrollTo(0, document.documentElement.scrollHeight)
                }, 50);

            },
            imageLocation(image) {
                return vas.imageUrl(image);
            },
            micStart() {
                this.showRecording = true;

                window.plugins.audioRecorderAPI.record(function (msg) {
                    // complete
                    alert('record - ok: ' + msg);
                }, function (msg) {
                    // failed
                    alert('record - ko: ' + msg);
                }, 600);
            },
            updateLoadAudio(data) {
                var self = this;

                Loading.show('');

                vas.sendChatAudio(this.auth.user.cell_no,
                    this.auth.user.user_id,
                    this.chatId,
                    data)
                    .then(function (result) {
                        self.addMessage({
                            message: result.path,
                            time: moment(),
                            user: true,
                            type: 'audio'
                        });

                        Repository.Message.save(result.chat_log_id, self.chatId, result.path, "audio", moment().valueOf(), self.nurse.id, function (res) {
                            console.log(res);
                        });

                        Loading.hide();
                    })
                    .catch(function (error) {
                        console.log(error);
                        Loading.hide();
                    });
            },
            micEnd() {
                var self = this;
                this.showRecording = false;
                window.plugins.audioRecorderAPI.stop(function (filename) {
                    window.resolveLocalFileSystemURL('file://' + filename, function (success) {
                        success.file(function (file) {
                            console.log(file);

                            var reader = new FileReader();
                            reader.onloadend = function (evt) {
                                var encoded = evt.target.result.replace(/^.*;base64,/, '');

                                if ((encoded.length % 4) > 0) {
                                    encoded += '='.repeat(4 - (encoded.length % 4));
                                }

                                self.updateLoadAudio(encoded);
                            };

                            reader.readAsDataURL(file);
                        }, function (fail) {
                            console.log(fail);
                        });
                    }, function (error) {
                        console.log(error);
                    });
                }, function (msg) {
                });
            },
            photo() {
                navigator.camera.getPicture(this.photoSucess, this.photoError, {
                    destinationType: Camera.DestinationType.DATA_URL,
                    correctOrientation: true
                });
            },
            photoSucess(imageData) {
                var self = this;

                Loading.show('');

                vas.sendChatImage(this.auth.user.cell_no,
                    this.auth.user.user_id,
                    this.chatId,
                    imageData)
                    .then(function (result) {
                        self.addMessage({
                            message: result.path,
                            time: moment(),
                            user: true,
                            type: 'image'
                        });

                        console.log(result);

                        Repository.Message.save(result.chat_log_id, self.chatId, result.path, "image", moment().valueOf(), self.nurse.id, function (res) {
                            console.log(res);
                        });

                        Loading.hide();
                    })
                    .catch(function (error) {
                        console.log(error);

                        Loading.hide();
                    });
            },
            photoError() {

            },
            setInputHeight() {
                if (this.isEnded) {
                    return;
                }

                var restoreEmptyMessage = false;
                if (this.message === '') {
                    this.message = ' ';
                    restoreEmptyMessage = true;
                }

                this.$refs.message.calculateInputHeight();

                var height = parseInt(this.$refs.message.$refs.input.style.height);
                var paddingTop = parseInt(this.$refs.messageOuter.style.paddingTop);
                var paddingBottom = parseInt(this.$refs.messageOuter.style.paddingBottom);

                this.$refs.messageOuter.style.height = (height + paddingTop + paddingBottom) + 'px';
                this.$refs.messageWrapper.style.height = (height) + 'px';

                if (restoreEmptyMessage) {
                    this.message = '';
                }
            },
            callback() {
                var self = this;
                Loading.show('');
                self.showCallback = false;

                vas.requestCallback(this.auth.user.cell_no,
                    this.auth.user.user_id,
                    this.chatId)
                    .then(function (response) {
                        self.rating = 0;

                        Loading.hide();

                        self.showCallbackComplete = true;
                    })
                    .catch(function (response) {
                        Loading.hide();
                    });
            },
            rate() {
                var self = this;
                Loading.show('');
                self.showRating = false;

                vas.rateChat(this.auth.user.cell_no,
                    this.auth.user.user_id,
                    this.chatId,
                    this.rating)
                    .then(function (response) {
                        self.rating = 0;

                        Loading.hide();

                        self.showRatingComplete = true;
                    })
                    .catch(function (response) {
                        Loading.hide();
                    });
            },
            endChat() {
                vas.endChat(this.chatId);

                this.$router.go(-1);
            },
            messageReceived(message) {
                if (message.chat_id != this.chatId) {
                    return;
                }

                this.addMessage({
                    message: message.chat_message,
                    time: moment(),
                    user: false,
                    type: 'text'
                });
            },
            send() {
                var self = this;

                this.addMessage({
                    message: this.message,
                    time: moment(),
                    user: true,
                    type: 'text'
                });

                vas.sendChatMessage(this.auth.user.cell_no,
                    this.auth.user.user_id,
                    this.chatId,
                    this.message
                ).then(function (response) {
                    Repository.Message.save(response.chat_log_id, self.chatId, response.path, "audio", moment().valueOf(), self.nurse.id, function (res) {
                        console.log(res);
                    });

                    console.log(response);
                });

                this.message = '';

                setTimeout(this.setInputHeight, 0);
            },
            updateTime() {
                var duration = new Date().getTime() - this.start;

                if (this.isEnded) {
                    if (this.endDate == null) {
                        this.displayTime = null;

                        return;
                    } else {
                        duration = this.endDate.valueOf() - this.start;
                    }
                }

                if (duration < 0) {
                    duration = 0;
                }

                var milliseconds = parseInt((duration % 1000) / 100),
                    seconds = parseInt((duration / 1000) % 60),
                    minutes = parseInt((duration / (1000 * 60)) % 60),
                    hours = parseInt((duration / (1000 * 60 * 60)) % 24);

                hours = (hours < 10) ? "0" + hours : hours;
                minutes = (minutes < 10) ? "0" + minutes : minutes;
                seconds = (seconds < 10) ? "0" + seconds : seconds;

                this.displayTime = hours + ":" + minutes + ":" + seconds;
            },
            fetchChats() {
                var self = this;
                var last = this.chat[this.chat.length - 1];

                vas.fetchMessages(this.auth.user.cell_no,
                    this.auth.user.user_id,
                    this.chatId,
                    Math.round(last.time.valueOf() / 1000))
                    .then(function (result) {
                        result.messages.forEach(function (message) {
                            self.addMessage({
                                message: message.message,
                                time: moment(message.date, "YYYY-MM-DD HH:mm:ss"),
                                user: false,
                                type: 'text'
                            });
                        });

                        if (result.practitioner.id != self.nurse.id) {
                            self.nurse.id = result.practitioner;
                            self.nurse.name = result.practitioner.name;
                            self.nurse.qualification = result.practitioner.qualification;
                            self.nurse.university = result.practitioner.university;

                            if (result.practitioner.img != null && result.practitioner.img != '') {
                                self.nurse.img = vas.imageUrl(result.practitioner.img);
                            } else {
                                self.nurse.img = require('../../../variants/' + BUILD_VARIANT + "/practitioner.png");
                            }
                        }

                        self.isEnded = !result.active;
                    });
            }
        },
        created() {
            this.chat = [];

            this.timer = setInterval(this.updateTime, 100);

            EventBus.$on('app-msg-received', this.messageReceived);

            if (window.plugins && window.plugins.audioRecorderAPI) {
                this.allowAudio = true;
            }

            if (!this.cordova) {
                this.chatTimer = setInterval(this.fetchChats, 10000);
            }
        },
        destroyed() {
            clearInterval(this.timer);

            if (this.chatTimer !== null) {
                clearInterval(this.chatTimer);
            }
        },
        mounted() {
            var self = this;
            Loading.show('');

            vas.createChat(this.auth.user.user_id, this.auth.user.cell_no, this.$route.params.chatId ? this.$route.params.chatId : null).then(function (result) {
                if (!result.status) {
                    throw new Error(result.error);
                }

                Loading.hide();

                self.nurse.id = result.attorney_id;
                self.nurse.name = result.attorney_name;
                self.nurse.qualification = result.attorney_qualification;
                self.nurse.university = result.attorney_university;

                if (result.attorney_image != null && result.attorney_image != '') {
                    self.nurse.img = vas.imageUrl(result.attorney_image);
                } else {
                    self.nurse.img = require('../../../variants/' + BUILD_VARIANT + "/practitioner.png");
                }
                self.isEnded = result.chat_ended;

                if (self.isEnded) {
                    if (result.chat_end_date == null) {
                    } else {
                        self.endDate = moment(result.chat_end_date, "YYYY-MM-DD HH:mm:ss");
                    }
                }
                self.start = moment(result.chat_date, "YYYY-MM-DD HH:mm:ss").valueOf();

                Repository.Practitioner.save(result.attorney_id,
                    result.attorney_name,
                    '',
                    '',
                    result.attorney_qualification,
                    result.attorney_university,
                    '',
                    result.attorney_image,
                    function (res) {
                        console.log(res);
                    }
                );

                Repository.Chat.save(result.chat_id,
                    self.auth.user.user_id,
                    result.attorney_id,
                    moment(result.chat_date, "YYYY-MM-DD HH:mm:ss").valueOf(),
                    self.endDate == null ? null : self.endDate.valueOf(),
                    function (res) {
                        console.log(res);
                    }
                );

                self.chatId = result.chat_id;

                if (result.attorney_id === '0') {
                    self.addMessage({
                        message: 'Hi there. Our ' + config.practitioner.plural_type + ' are currently busy. Post your question below, and I will pass it on as soon as one becomes available',
                        time: moment(result.chat_date, "YYYY-MM-DD HH:mm:ss"),
                        user: false,
                        type: 'text'
                    });
                } else {
                    self.addMessage({
                        message: 'Welcome to ' + config.app.name + '. How can we help you?',
                        time: moment(result.chat_date, "YYYY-MM-DD HH:mm:ss"),
                        user: false,
                        type: 'text'
                    });
                }

                // for (var i = 1; i <= 100; i++) {
                //     self.addMessage({
                //         message: 'Test ' + i,
                //         time: moment(result.chat_date, "YYYY-MM-DD HH:mm:ss"),
                //         user: false,
                //         type: 'text'
                //     });
                // }

                if (result.messages) {
                    result.messages.forEach(function (message) {
                        message.message = message.message.trim();

                        if (message.message != null && message.message != '') {
                            self.addMessage({
                                message: message.message,
                                time: moment(message.date, "YYYY-MM-DD HH:mm:ss"),
                                user: message.user,
                                type: message.type
                            });
                        }
                    });
                }

                setTimeout(function () {
                    this.message = ' ';
                    self.setInputHeight();
                    this.message = '';
                }, 0);
            }).catch(function (result) {
                self.errorMessage = result.message;
                self.showError = true;

                Loading.hide();
            });
        }
    }
</script>
<style>
    .chat-footer {
        height: 100px;
        position: fixed;
        bottom: 0px;
        left: 0px;
        right: 0px;
    }

    .chat-content {
        padding-top: 0px;
        padding-bottom: 100px;
    }

    .speech-bubble-left-outer {
        margin: 10px 15px;
    }

    .speech-bubble-right-outer {
        margin: 10px 15px;
        text-align: right;
    }

    .speech-bubble-left {
        min-width: 130px;
        max-width: 90%;
        position: relative;
        background: #587a32;
        border-radius: .4em;
        color: #fff;
        padding: 8px 15px;
        display: inline-block;
    }

    .speech-bubble-left:after {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        width: 0;
        height: 0;
        border: 20px solid transparent;
        border-right-color: #587a32;
        border-left: 0;
        border-bottom: 0;
        margin-top: -10px;
        margin-left: -20px;
    }

    .speech-bubble-right {
        min-width: 130px;
        max-width: 90%;
        position: relative;
        background: #90b636;
        border-radius: .4em;
        display: inline-block;
        padding: 8px 15px;
    }

    .speech-bubble-right:after {
        content: '';
        position: absolute;
        right: 0;
        top: 50%;
        width: 0;
        height: 0;
        border: 20px solid transparent;
        border-left-color: #90b636;
        border-right: 0;
        border-bottom: 0;
        margin-top: -10px;
        margin-right: -20px;
    }

    .chat-footer .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
        background: transparent;
        box-shadow: none;
    }

    .chat-footer .v-textarea.v-text-field--enclosed.v-text-field--single-line textarea {
        margin-top: 25px;
        padding-top: 10px;
        padding-bottom: 10px;
    }
</style>
